import { Card, Checkbox, Col, List, Modal } from 'antd';
import React, { useState } from 'react';
import { ParAssetCatalogOptionResponse } from 'services/assetconfig';
import { toCurrency } from 'utils/utils';

type AssetListOptionsModalProps = {
  visible: boolean;
  listOptions: ParAssetCatalogOptionResponse[];
  onSave: any;
  onCancel: () => void;
  assetComponents: any[];
};

const AssetListOptionsModal = (props: AssetListOptionsModalProps) => {
  const { visible, onCancel, listOptions, onSave, assetComponents } = props;


  const [selectedOption, setselectedOption] = useState<
    ParAssetCatalogOptionResponse[]
  >([]);

  const onSelect = () => {
    onSave(selectedOption);
    onCancel();
  };

  return (
    (<Modal
      open={visible}
      title="list options"
      onCancel={onCancel}
      width="700px"
      onOk={onSelect}
    >
      <Card>
        {listOptions?.length > 0 && (
          <List
            size="small"
            style={{ width: '100%' }}
            dataSource={listOptions ?? []}
            renderItem={(e) => (
              <List.Item>
                <Checkbox
                  value={e.optvalue}
                  onChange={(a) => {
                    if (a.target.checked) {
                      setselectedOption([...selectedOption, e]);
                    } else {
                      let items = selectedOption.filter(
                        (i) => i.optvalue !== a.target.value 
                      );

                      setselectedOption(items);
                    }
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Col>
                      {`${e.optcodelabel} 
                              : 
                              ${e.optvaluelabel ? e.optvaluelabel : ''} 
                              : 
                              ${toCurrency(e.optnetamount, localStorage.getItem('currcode') ?? '')}`}
                    </Col>
                  </div>
                </Checkbox>
              </List.Item>
            )}
          />
        )}
      </Card>
    </Modal>)
  );
};

export default AssetListOptionsModal;
